import React from "react"
import 'photoswipe/dist/photoswipe.css'

import { Gallery, Item } from 'react-photoswipe-gallery'
import StyledImage from "./styled-image"
import Carousel from "./carousel"

export default function LightboxGallery({ props, isCarousel, settingsOverrides, aspectRatio }) {
  const images = props?.images
  const options = {
    counter: false,
  }

  return (
    <Gallery options={options} withCaption={true}>
      <>{isCarousel ?
        <Carousel settingsOverrides={settingsOverrides}>
          {images?.map((image, index) => {
            return (
              GalleryItem(index, image, aspectRatio)
            )
          })}
        </Carousel>
        : images?.map((image, index) => {
          return (
            GalleryItem(index, image, aspectRatio)
          )
        })
      }</>
    </Gallery>
  )
}

function GalleryItem(index, image, aspectRatio) {
  return (
    <>
      {image ? <Item
        key={index}
        original={image.localFile?.childImageSharp?.original?.src}
        width={image?.localFile?.childImageSharp?.original?.width}
        height={image?.localFile?.childImageSharp?.original?.height}
        alt={image?.altText}
        caption={image?.caption || "&nbsp;"}
      >
        {({ ref, open }) => (
          <button ref={ref}
            className="cursor-pointer -mx-4 xl:-mx-6 px-4 xl:px-6 relative"
            onClick={open}>
            <StyledImage
              image={image}
              objectFit="cover"
              className={`mx-4 xl:mx-6 ${aspectRatio === "video" ? "aspect-video" : ""} `}
              objectPosition={"center"} />
          </button>
        )}
      </Item> : null}
    </>)
}
